// PageDescription: 의사 상세 페이지
import DefaultLayout from '@/components/layouts/DefaultLayout';
import DoctorDetailTemplate from '@/components/templates/doctor/detail/DoctorDetailTemplate';
import useDoctorDetailViewModel from '@/components/templates/doctor/detail/useDoctorDetailViewModel';
import useDoctorReviewsViewModel from '@/components/templates/doctor/detail/useDoctorReviewsViewModel';
import { CustomPageProps } from '@/types/app';

const DoctorDetailPage = ({ client }: CustomPageProps) => {
  const doctorDetailViewModel = useDoctorDetailViewModel(client);
  const doctorReviewsViewModel = useDoctorReviewsViewModel();

  return (
    <DoctorDetailTemplate
      client={client}
      doctorDetailViewModel={doctorDetailViewModel}
      doctorReviewsViewModel={doctorReviewsViewModel}
    />
  );
};

export default DoctorDetailPage;

DoctorDetailPage.Layout = DefaultLayout;
